import axios from 'axios'

/**
 * 앱 전역 HTTP 클라이언트.
 *
 * 이 파일이 생기기 전에는 API 주소가 두 갈래로 갈라져 있었다.
 *   - API_BASE 상수를 각자 정의한 파일 5개  → 개발 시 work.irudalab.com:3001
 *   - '/api/...' 를 상대경로로 하드코딩한 곳 15곳 → devServer 프록시를 타고 localhost:3000
 * 그 결과 개발 환경에서 공휴일·지오코딩·관리자 화면만 다른 서버와 통신했다.
 * (같은 월 그리드인데 MonthView 는 상대경로, TaskMonthView 는 API_BASE 를 쓰는 식)
 *
 * 주소 결정은 여기 한 곳에서만 한다.
 *   VUE_APP_API_BASE 가 있으면 그것을 쓰고,
 *   없으면 운영은 동일 출처(''), 개발은 프록시를 타도록 '' 를 쓴다.
 *
 * 개발에서 원격 서버를 직접 보고 싶으면 client/.env.development.local 에
 *   VUE_APP_API_BASE=https://work.irudalab.com:3001
 * 을 두면 된다. vue.config.js 의 devServer 프록시(/api, /auth → localhost:3000)가
 * 기본 경로이므로 평소에는 설정할 필요가 없다.
 */
export const API_BASE = process.env.VUE_APP_API_BASE || ''

const http = axios.create({
  baseURL: API_BASE,
  // 세션 쿠키(iruda_session) 전송에 필수
  withCredentials: true
})

export default http
